/* global Shopify */
import { listen, isMatching } from "@utils/bph";
import Flickity from "flickity";
import gsap, { ScrollToPlugin } from "gsap/all";

gsap.registerPlugin(ScrollToPlugin);

export default ({ variantId, mediaId, variants }) => ({
  variantId,
  mediaId,
  variants,
  thumbCount: variants.length,
  thumbMax: 5,
  variantIdx: 0,
  isHidden: true,
  currentVariant: null,
  thumbListener: null,
  flickity: null,
  loading: false,
  hasError: false,
  errorMsg: "",

  init() {
    this.updateVariant(false);
    this.thumbListener = listen("2xl", ({ matches }) => {
      this.thumbMax = matches ? 6 : 5;
    });

    if (
      (this.thumbCount > this.thumbMax &&
        this.variantIdx + 1 >= this.thumbMax) ||
      this.thumbCount === this.thumbMax
    ) {
      this.isHidden = false;
    }

    this.$nextTick(() => {
      this.sliderListener = listen("lg", ({ matches }) =>
        this.toggleSlider(matches)
      );
    });
  },

  toggleSlider(matches) {
    if (matches) {
      this.destroySlider();
    } else {
      this.initSlider();
    }
  },

  initSlider() {
    this.flickity = new Flickity(this.$refs.slider, {
      cellSelector: ".visible-image",
      prevNextButtons: false,
    });

    if (this.flickity.slides.length <= 1) {
      this.destroySlider();
    }
  },

  destroySlider() {
    if (this.flickity) {
      this.flickity.destroy();
      this.flickity = null;
    }
  },

  updateVariant(updatePath = true) {
    this.destroySlider();
    this.currentVariant = this.variants.find((variant, idx) => {
      if (variant.id.toString() === this.variantId) {
        this.variantIdx = idx;
        this.mediaId = `${variant.featured_media?.id}` || null;
        return true;
      }
      return false;
    });

    this.updateInventory(this.variantId);

    if (!updatePath) return;
    const url = `${window.location.pathname}?variant=${this.variantId}`;
    history.replaceState({ path: url }, null, url);
    this.$nextTick(() => this.toggleSlider(isMatching("lg")));
    if (isMatching("lg")) gsap.to(window, { scrollTo: 0, duration: 0.2 });
  },

  updateInventory(id) {
    this.loadInventory = true;
    fetch(
      `${window.location.origin}/variants/${id}/?section_id=inventory-quantity`,
      {
        credentials: "same-origin",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
      }
    )
      .then((res) => res.text())
      .then((html) => {
        if (html.trim() === "") return;
        this.loadInventory = false;
        this.$refs.inventory.innerHTML = html;
      })
      .catch((error) => {
        this.loadInventory = false;
        console.error("Error:", error);
      });
  },

  formatPrice(price) {
    return `${Shopify.currency.active} ${(price / 100)
      .toFixed(2)
      .replace(".00", ".–")}`;
  },

  moreThumbsLabel({ one, many }) {
    const count = this.thumbCount - this.thumbMax + 1;

    if (count === 1) {
      return one;
    } else {
      return many.replace("%s%", count);
    }
  },

  destroy() {
    this.destroySlider();
    this.sliderListener.off();
    this.thumbListener.off();
  },

  form: {
    async ["@submit.prevent"]() {
      this.loading = true;
      this.hasError = false;
      this.errorMsg = "";
      const data = new FormData(this.$refs.form);
      data.append("sections", ["cart-bubble", "cart-drawer"]);
      data.append("sections_url", window.location.pathname);

      const response = await fetch(`${window.routes.cart_add_url}.js`, {
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
        },
        body: data,
      });
      const json = await response.json();

      if ("description" in json) {
        this.errorMsg = json.description;
        this.hasError = true;
        this.loading = false;
        return;
      }

      this.loading = false;

      this.$dispatch("updatebubble", json.sections["cart-bubble"]);
      this.$dispatch("updatedrawer", json.sections["cart-drawer"]);
      this.$dispatch("opencart");
    },
  },
});
